module.exports = __webpack_public_path__ + "img/icCard.b3dec45c.png";